export default function isValidHtmlId(input: string) {
  return /^[a-zA-Z][\w:.-]*$/.test(input);
}
